import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlInputModule, BlFocusModule, BlDialogModule } from '@blcloud/bl-ng-ui-component';

import { LoginPageComponent } from './login-page.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule.forRoot(),

    BlNgCommonModule,
    BlInputModule,
    BlFocusModule,
    BlDialogModule,
  ],
  declarations: [
    LoginPageComponent,
  ],
})
export class LoginPageModule {}



// WEBPACK FOOTER //
// ./src/app/page/login-page/login-page.module.ts